import app from 'firebase/app'
import 'firebase/auth'
import 'firebase/firebase-firestore'
const config = {
    apiKey: "AIzaSyASNXhfa9YOFQUh6sb0JkaFFtF3GxpYxgY",
    authDomain: "gotta-go-4cbcb.firebaseapp.com",
    databaseURL: "https://gotta-go-4cbcb.firebaseio.com",
    projectId: "gotta-go-4cbcb",
    storageBucket: "gotta-go-4cbcb.appspot.com",
    messagingSenderId: "632875817321",
    appId: "1:632875817321:web:8a14181acd4303749505f8",
    measurementId: "G-P3YC46LM98"
}

class Firebase {
    constructor() {
        app.initializeApp(config);
        this.auth = app.auth();
        this.db = app.firestore();
    }

    login(email, password) {
        this.isLogin = true;
        return this
            .auth
            .signInWithEmailAndPassword(email, password)
    }
    logout() {
        this.isLogin = false;
        return this
            .auth
            .signOut()
    }
    async register(name, email, password) {
        const authRes = await this
            .auth
            .createUserWithEmailAndPassword(email, password);
        const userObj = {
            email: authRes.user.email,
            name: name
        };
        await this
            .db
            .collection('users')
            .doc(email)
            .set(userObj)
        return this
            .auth
            .currentUser
            .updateProfile({displayName: name})
    }
    userLogin() {
        this
            .auth
            .onAuthStateChanged(_usr => {
                if (_usr === null) {
                    return false;
                }
            })
        return true;
    }
    getUserChatList(setEmail, setChats) {
        this
            .auth
            .onAuthStateChanged(async _usr => {
                if (_usr !== null) {
                    this
                        .db
                        .collection('chats')
                        .where('users', 'array-contains', _usr.email)
                        .onSnapshot(async res => {
                            const chats = res
                                .docs
                                .map(_doc => _doc.data())
                            await setChats(chats)
                            await setEmail(_usr.email)
                        });
                }
            })
    }

    addMessage(email, msg, docKey) {
        this
            .db
            .collection('chats')
            .doc(docKey)
            .update({
                messages: app
                    .firestore
                    .FieldValue
                    .arrayUnion({
                        sender: email,
                        message: msg,
                        timestamp: Date.now()
                    }),
                receiverHasRead: false
            })
    }
    hasRead(docKey) {
        this
            .db
            .collection('chats')
            .doc(docKey)
            .update({receiverHasRead: true})
    }
    userExist = async(email) => {
        const usersSnapshot = await this
            .db
            .collection('users')
            .get();
        const exists = usersSnapshot
            .docs
            .map(doc => doc.data().email)
            .includes(email);
        return exists;
    }
    newChatSubmit(docKey, email, chatObj) {
        const g = {
            receiverHasRead: false,
            users: [
                email, chatObj.sendTo
            ],
            messages: [
                {
                    message: chatObj.message,
                    sender: email
                }
            ]
        };
        console.log(g);
        this
            .db
            .collection('chats')
            .doc(docKey)
            .set(g)
    }
}

export default new Firebase();